import { render, staticRenderFns } from "./OrderDetailStudio7.vue?vue&type=template&id=0cd69f8e&scoped=true"
import script from "./OrderDetailStudio7.vue?vue&type=script&lang=js"
export * from "./OrderDetailStudio7.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailStudio7.vue?vue&type=style&index=0&id=0cd69f8e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd69f8e",
  null
  
)

export default component.exports